import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { TextareaModule } from 'primeng/textarea';
import { RadioButton } from 'primeng/radiobutton';
import { TranslateModule } from '@ngx-translate/core';
import { QuestionWithAnswer } from '../redacteur-dac-group.component';

@Component({
  selector: 'sm-redacteur-question-list',
  standalone: true,
  imports: [CommonModule, FormsModule, CheckboxModule, TextareaModule, RadioButton, TranslateModule],
  templateUrl: './redacteur-question-list.component.html',
  styleUrls: ['./redacteur-question-list.component.scss'],
})
export class RedacteurQuestionListComponent {
  @Input() questions!: QuestionWithAnswer[];
  @Input() onSelectionChange?: (index: number, selected: boolean) => void;
  @Input() onAnswerChange?: (index: number, answer: string) => void;
  @Input() onTypeChange?: (index: number, type: 'SIMPLE' | 'ADDITIF') => void;

  onCheckboxChange(index: number, event: { checked?: boolean }) {
    if (this.onSelectionChange) {
      this.onSelectionChange(index, event.checked ?? false);
    }
  }

  onAnswerInput(index: number, event: Event) {
    const value = (event.target as HTMLTextAreaElement).value;
    if (this.onAnswerChange) {
      this.onAnswerChange(index, value);
    }
  }

  onTypeChangeInternal(index: number, type: 'SIMPLE' | 'ADDITIF') {
    if (this.onTypeChange) {
      this.onTypeChange(index, type);
    }
  }
}
